module.exports = __webpack_public_path__ + "img/icn_brillanti.923f7a70.svg";